import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import SuspensePageLoading from "../../../components/SuspensePageLoading";
import { links } from "./links";



const Dashboard = lazy(() => import("../../../pages/Dashboard"));
const Discovery = lazy(() => import("../../../pages/Discovery"));
const Agencies = lazy(() => import("../../../pages/Agencies"));
const Influencers = lazy(() => import("../../../pages/Influencers"));
const Categories = lazy(() => import("../../../pages/Categories"));
const InfluencerDetails = lazy(() => import("../../../pages/Influencers/Details"));
const AgencyDetails = lazy(() => import("../../../pages/Agencies/Details"));
const Profile = lazy(() => import("../../../pages/Profile"));


const AdminRoutes = () => {
    
  return (
    <>
      <Sidebar links={links} />
        <Suspense fallback={<SuspensePageLoading />}>
          <Routes>
            
            <Route path="/" element={<Dashboard />} />
            {/* <Route path="/discovery" element={<Discovery />} /> */}
            <Route path="/agencies" element={<Agencies />} />
            <Route path="/influencers" element={<Influencers />} />
            {/* <Route path="/categories" element={<Categories/>} /> */}
            <Route path="/influencer/:id" element={<InfluencerDetails/>} />
            {/* <Route path="/agency/:id" element={<AgencyDetails/>} /> */}
            <Route path="/profile" element={<Profile/>} />




            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
    </>
  );
};

export default AdminRoutes;
